import { stringManipulator } from './search-types';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function useSearchUtils() {
  const transformFilter = (
    filter: string,
    transformCallBack: stringManipulator
  ): string => {
    if (!filter.includes('.')) {
      return transformCallBack(filter);
    }

    return filter
      .split('.')
      .map((filterKeyPart) => transformCallBack(filterKeyPart))
      .join('.');
  };

  return {
    transformFilter,
  };
}
